<template>
  <div v-if="item.url || item.base64" class="preview">
    <div class="filePreview">
      <div class="file-wrap">
        <v-icon v-if="CheckPDF(item)" color="primary" size="30">mdi-file-pdf</v-icon>
        <div v-else class="imageUpload">
          <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
          >
            <template v-slot:activator="{ on, attrs }">
              <img v-if="GetFilePath(item)" :src="GetFilePath(item)" v-bind="attrs" v-on="on" title="Посмотреть"/>
            </template>
            <template v-slot:default="dialog">
              <div class="modal-dialog">
                <img v-if="GetFilePath(item)" :src="GetFilePath(item)"/>
                <v-btn
                  class="modal-dialog--close"
                  color="primary"
                  button
                  icon
                  @click="dialog.value = false"
                ><v-icon>mdi-close</v-icon></v-btn>
              </div>
            </template>
          </v-dialog>
        </div>
        <div class="nameUpload">{{item.name}}</div>
        <v-icon v-if="edit" class="close" dense color="red" @click="$emit('remove')">mdi-delete-circle</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewImgComponent',
  props: ['item', 'edit'],
  methods: {
    /**
     * Проверка типа документа.
     * @param item {Object} объект документа.
     * @returns {*|boolean}
     */
    CheckPDF(item) {
      if (item.base64) {
        return (item.base64.includes('/pdf;'));
      }
      if (item.url) {
        return (item.url.includes('.pdf'));
      }
      return false;
    },
    /**
     * Получение пути до файла.
     * @param item объект документа.
     * @returns {*}
     */
    GetFilePath(item) {
      if (item.base64 || item.url) {
        return item.url ? item.url : item.base64;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.preview {
  &__icon {
    color: red;
  }
}

.imageUpload {
  width: 100%;
  height: 100%;
}

.preview__icon,
.imageUpload img {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 10px;
}

.filePreview {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 50px;
    .file-wrap{
      display: flex;
      align-items: center;
      height: 100%;
      padding: 5px 10px;
      margin: 0 10px;
      border: 1px solid #e1e1e1;
      box-shadow: inset 0 1px 0 0 #fff, inset 0 -1px 0 0 #d9d9d9, inset 0 0 0 1px #f2f2f2, 0 2px 4px 0 #f2f2f2;
      -moz-box-shadow: inset 0 1px 0 0 #fff, inset 0 -1px 0 0 #d9d9d9, inset 0 0 0 1px #f2f2f2, 0 2px 4px 0 #f2f2f2;
      border-radius: 4px;
    }
  .image-wrap{
    display: flex;
  }
  .imageUpload{
    flex-shrink: 0;
    border:1px solid #ccc;
    border-radius: 10px;
    width: 36px;
    height: 36px;
    object-fit: cover;
  }
  .nameUpload{
    margin-left: 10px;
    white-space: nowrap;
    max-width: 90px;
    overflow: hidden;
  }

  .close {
    margin-left: 10px;
    background-color: $color-white-a5;
    border-radius: 50%;
    transition: all .5s ease;

    &:hover {
      background-color: $color-white-a8;
      border-radius: 0;
      transition: all .5s ease;
    }
  }
}

</style>
